import { useMutation } from "@apollo/client";
import { DO_FORGOT, DO_LOGIN, DO_RESEST } from "@operations/loginOperations";

export const useLogin = () => useMutation(DO_LOGIN);
export const useForgot = () => useMutation(DO_FORGOT);
export const useReset = () => useMutation(DO_RESEST);
